import { action } from 'satcheljs';

export default action('GET_REMINDERS_FOR_WEBPUSH');
